import React, { Component } from 'react';
import RaisedButton from 'material-ui/RaisedButton'
import muiThemeable from 'material-ui/styles/muiThemeable';

export default muiThemeable()(class SignupButton extends Component {
  openSignup = () =>  {
    window.location = this.props.artists ? "/artist-signup" : "/signup";
  }

  render() {
    return (
        <RaisedButton onClick={this.openSignup} style={Object.assign({}, this.props.style, {color: this.props.muiTheme.palette.alternateTextColor})}
                      primary={this.props.primary} secondary={this.props.secondary}>
          {this.props.children}
        </RaisedButton>
    );
  }
})



// WEBPACK FOOTER //
// ./src/SignupButton.js